/* eslint-disable @next/next/no-head-element */
/* eslint-disable @next/next/no-page-custom-font */
import Link from 'next/link';
import { ReactNode } from 'react';
import { Open_Sans, DM_Mono } from 'next/font/google';

import { ROUTES } from '@/constants/routes/default';
import HeaderLinks from '../../HeaderLinks';
import FooterDC from '../FooterDC';

import './DefaultLayoutDC.css';
import Image from 'next/image';

export const metadata = {
  title: 'Opportunities | Davidcareers',
  description: 'Find the best opportunities at Davidcareers',
};

interface LayoutProps {
  children: ReactNode;
}

const openSans = Open_Sans({
  subsets: ['latin'],
  weight: ['400', '700'],
  display: 'swap',
  variable: '--font-open-sans', // Define a CSS variable for Open Sans
});

const dmMono = DM_Mono({
  subsets: ['latin'],
  weight: ['400', '500'],
  display: 'swap',
  variable: '--font-dm-mono', // Define a CSS variable for DM Mono
});

const DefaultLayoutDC = async ({ children }: LayoutProps) => {
  return (
    <html lang="en" className={`${openSans.variable} ${dmMono.variable}`}>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body className="body-dc">
        <link rel="shortcut icon" href="/dc/favicon.ico" />
        <div className="h-full flex flex-col justify-between">
          <div>
            <header className="flex md:px-10 max-md:px-4 min-h-[88px] header-dc">
              <div className="max-w-[960px] w-full h-full flex justify-between items-center m-auto flex-wrap gap-4">
                <Link href={ROUTES.home} aria-label="DavidCareers Logo">
                  <Image
                    width="113"
                    height="52"
                    src="https://assets.davidcareers.com/davidcareers/cont_regular/logo_hr.png"
                    alt="Logo"
                    unoptimized
                    priority
                  />
                </Link>
                <HeaderLinks
                  listHeaderCn="px-3.5 py-2 text-dove-gray"
                  dropdownClassNames={{
                    listCn: 'max-w-[200px] right-0 bg-white py-3 header-dc-menu rounded-2xl',
                    elementCn: 'text-sm h-9 px-4 flex items-center hover:bg-gallery2',
                    rootCn: '',
                    iconCn: 'h-9 w-9 rounded-full hover:bg-white header-dc-menu-icon-with-hover',
                    activeIconCn: 'bg-white header-dc-menu-icon',
                  }}
                  componentCn="flex gap-6 items-baseline"
                  linkCn="uppercase text-cod-gray text-sm hover:translate-y-1"
                  skipSession
                />
              </div>
            </header>
            <main>{children}</main>
          </div>
          <div>
            <div className="h-2 min-h-2 bg-vermilion" />
            <FooterDC isAuthorized={false} />
          </div>
        </div>
      </body>
    </html>
  );
};

export default DefaultLayoutDC;
